import NoSpaceModal from './NoSpaceModal.view';

export default NoSpaceModal;
